<template lang="html">
  <div class="startup_page" id="content">
    <AddToListModal v-if="sf" :searchfield="sf" :dialogVisible='dialogList'  @close="closeModalList()" @toExisting="toExisting($event)" @toNew="toNewList($event)"></AddToListModal>
    <AddToListModalAlt  :dialogVisible='dialogListAlt'  @close="dialogListAlt = false" @toExisting="toExistingAlt($event)"></AddToListModalAlt>
    <ConfirmModal :dialogVisible='dialogAffinity' @close="dialogAffinity = false" @confirmed="sendAffinity($event)" message="The selected companies will be synchronized in Affinity" ></ConfirmModal>

    <div class="container ">

      <div class="row startup">
        <div class="col-12 startup_banner" v-if="startup_image">
             <img :src="this.apiUrl+'/get_image/'+startup_image+'?token='+$store.state.innotoken" alt="" class="startup_banner" v-if="startup_image">
             <div class="startup_logo" v-if="startup_logo">
               <div class="startup_logo_inside">
                 <div class="" v-if="startup_logo">
                   <img :src="this.apiUrl+'/get_image/'+startup_logo+'?token='+$store.state.innotoken" alt="" class="" v-if="startup_logo">
                 </div>


               </div>

             </div>

        </div>
        <div class="pad0" v-if="startup_logo">
          <div class="startupName"  v-if="startup" style="padding-top:100px;">
            <!-- {{startup.name}} -->
          </div>

        </div>


        <div class="action_zone">
          <span class="actionZoneTitle" >Choose your action</span>
          <!-- <span class="actionZoneTitle"  v-else>{{startup.name}}</span> -->
         <!-- <router-link class="prev_step_btn_small" v-if="selected_filters.length > 0" :to="'/startup_with_filters_graph/'+this.$route.params.search_field+'/'+JSON.stringify(selected_filters)+'/'+this.$route.params.pid">Graph view</router-link> -->
         <div class="goRight"  v-if="sf != 'undefined'">
           <div class="zoneBtn" >
             <button type="button" class="action_btn" name="button" @click="openModalList" >Add to a list</button>
           </div>
           <div class="zoneBtn" v-if="showAffinity">
             <button type="button" class="action_btn" name="button" @click="dialogAffinity = true" >Affinity</button>
           </div>
           <div class="zoneBtn" :class="(can_assess == false) ? 'enableWhyDisabled' :'ok'">
             <button type="button" class="action_btn" :class="(can_assess == false) ? 'disabledRlink' :'ok'" name="button" @click="generateAssessment" :disabled="can_assess == false">Assess</button>
             <span class="whyDisabled">
               <span v-if="can_assess == false">Already in assessment stage</span>
             </span>
           </div>
         </div>

         <div class="goRight"  v-if="sf == 'undefined'">
           <div class="zoneBtn" >
             <button type="button" class="action_btn" name="button" @click="dialogListAlt = true" >Add to a list</button>
           </div>
           <div class="zoneBtn" v-if="showAffinity">
             <button type="button" class="action_btn" name="button" @click="dialogAffinity = true" >Affinity</button>
           </div>

         </div>

       </div>
       <div class="content_div" v-if="loadingAffinity">
         <div class="loaderInnopearl " >
           <div class="loaderInnopearlInner">
             <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
             <span>Synchronization of selected companies in Affinity in progress.</span>
           </div>

         </div>
       </div>

        <div class="content_div" v-else>

          <div class="row dflex revese pl20" v-if="startup.company_type">

            <div class="col-12 col-lg-6 col-xl-8 force50 force100" v-if="startup.company_type.value.toUpperCase() == 'STARTUP'">
              <h5 class="tblue"><strong>Summary</strong></h5>

              <StartupInfoLine v-if="startup.company_type" class="noBorder" className="inHeader" name="Company type" :value="startup.company_type"  />
              <StartupInfoLine v-else name="Company type" class="noBorder" className="inHeader" value="No data" />


              <StartupInfoLine v-if="startup.application_area" class="noBorder" className="inHeader" name="Application domain" :value="startup.application_area"  :isArray="Array.isArray(startup.application_area)"/>
              <StartupInfoLine v-else name="Application domain" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.value_proposition" class="noBorder" className="inHeader" name="Value proposition" :value="startup.value_proposition"  :isArray="Array.isArray(startup.value_proposition)"/>
              <StartupInfoLine v-else name="Value proposition" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.solution" name="solution" className="inHeader" class="noBorder" :value="startup.solution"/>
              <StartupInfoLine v-else name="solution" class="noBorder" className="inHeader" value="No data" />


              <StartupInfoLine v-if="startup.funding_stage" name="Funding stage" className="inHeader" class="noBorder" :value="startup.funding_stage"/>
              <StartupInfoLine v-else name="Funding stage" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.no_revenue_yet" class="noBorder" className="inHeader" name="Revenue" value="No revenue yet" />

                <StartupInfoLine v-else-if="startup.revenue" class="noBorder" className="inHeader" name="Revenue" :value="startup.revenue" :isCurrency="true"/>
                <StartupInfoLine v-else name="Revenue" class="noBorder"  className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.team_size" class="noBorder"  className="inHeader" name="Team size" :value="startup.team_size"/>
              <StartupInfoLine v-else  name="Team size"  class="noBorder" className="inHeader" value="No data" />

                <StartupInfoLine v-if="startup.location" class="noBorder" className="inHeader" name="Location" :isLocation="true" :value="startup.location" :isArray="Array.isArray(startup.location)"/>
                <StartupInfoLine v-else name="Location"  class="noBorder" className="inHeader" value="No data" />

            </div>
            <div class="col-12 col-lg-6 col-xl-8 force50 force100" v-else>
              <h5 class="tblue"><strong>Summary</strong></h5>

              <StartupInfoLine v-if="startup.company_type" class="noBorder" className="inHeader" name="Company type" :value="startup.company_type"  />
              <StartupInfoLine v-else name="Company type" class="noBorder" className="inHeader" value="No data" />


              <StartupInfoLine v-if="startup.application_area" class="noBorder" className="inHeader" name="Application domain" :value="startup.application_area"  :isArray="Array.isArray(startup.application_area)"/>
              <StartupInfoLine v-else name="Application domain" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.value_proposition" class="noBorder" className="inHeader" name="Value proposition" :value="startup.value_proposition"  :isArray="Array.isArray(startup.value_proposition)"/>
              <StartupInfoLine v-else name="Value proposition" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.solution" name="solution" className="inHeader" class="noBorder" :value="startup.solution"/>
              <StartupInfoLine v-else name="solution" class="noBorder" className="inHeader" value="No data" />


              <StartupInfoLine v-if="startup.location" class="noBorder" className="inHeader" name="Location" :isLocation="true" :value="startup.location" :isArray="Array.isArray(startup.location)"/>
              <StartupInfoLine v-else name="Location"  class="noBorder" className="inHeader" value="No data" />

            </div>
            <div class="col-12 col-lg-6 col-xl-4 force50">
              <h5 class="tdore fs30 text-center"><strong>{{startup.name}}</strong></h5>
              <div class="contactZone mt20" v-if="startup.key_contact_name || startup.key_contact_email || startup.website">
                <div class="mb20 dflexcontact">
                  <div class="contactIcon"><v-icon icon="mdi:mdi-account-circle-outline" /></div>
                  <div class="">
                    <h5><strong>Key contact</strong></h5>
                    <span class="contactInfo_kcn" v-if="startup.key_contact_name">{{startup.key_contact_name}}</span>
                  </div>

                </div>

                  <ul class="contactInfoList">
                    <li class="contactInfoItem" v-if="startup.key_contact_email">
                      <a :href="'mailto:'+startup.key_contact_email">{{startup.key_contact_email}}</a>
                    </li>
                    <li class="contactInfoItem" v-if="startup.key_contact_phone">
                      <a :href="'tel:'+startup.key_contact_phone">{{startup.key_contact_phone}}</a>
                    </li>
                    <li class="contactInfoItem" v-if="startup.website">
                      <a :href="website_formated" target="_blank">{{ getBaseUrl(startup.website) }}</a>
                    </li>

                  </ul>
              </div>
            </div>
          </div>


          <!-- <div class="col-12" >
               <img :src="this.apiUrl+'/get_image/'+startup_image+'?token='+$store.state.innotoken" alt="" class="startup_banner" v-if="startup_image">
               <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="startup_banner" alt="" v-else>

          </div> -->
          <div class="row mt50">
            <div class="col-12 " v-if="startup">

                <StartupInfoTab :startup="startup" :isRestrict="false"/>


              </div>
          </div>

          <div class="row center mt50">
            <div class="col-12 col-xl-6">
              <button v-if="canGoBack" class="prev_step_btn" @click="gobackrouter()">
                <img :src="require('@/assets/prev.svg')" alt="">
                BACK TO YOUR SELECTION
              </button>
            </div>

          </div>

        </div>


      </div>









    </div>



  </div>
</template>

<script>
import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import StartupFounders from '@/components/StartupFounders.vue'
import StartupInfoTab from '@/components/StartupInfoTab.vue'
import { toast } from 'vue-sonner'
import api from '../tools/api';
import _ from 'lodash';
import AddToListModal from '@/components/modals/addToList.vue'
import AddToListModalAlt from '@/components/modals/addToListAlt.vue'
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
export default {
  name : "StartupInfo",
  components: {
    StartupInfoTab,
    StartupInfoLine,
    AddToListModal,
    ConfirmModal,
    AddToListModalAlt
    // StartupFounders,
  },
  data() {
    return {
      pageInfo: {
        mainTitle : "Innovator profile",
        subTitle : "",
      },
      sf: null,
      can_assess: false,
      dialogAffinity: false,
      loadingAffinity:false,
      showAffinity:false,
      dialogList: false,
      dialogListAlt:false,
      visibleRef_readiness:false,
      visibleRef_analytical_support:false,
      visibleRef_strategic_fit: false,
      startup : {
        location: [],
        interest: 'medium',
        introduction: true,
        isSubmit: false,
      },
      apiUrl: process.env.VUE_APP_API_URL,
      tab: null,
    }
  },
  computed:{

    website_formated: function(){
      if(this.startup.website){
        if(this.startup.website.startsWith("https://") || this.startup.website.startsWith("http://")){
          return this.startup.website;
        }
        else{
          return "https://"+this.startup.website;
        }
      }
      else{
        return null;
      }

    },
    startup_image: function(){
      if(this.startup.image){
        console.log(this.startup.image);
        return this.startup.image.$oid;
      }
      else{
        return null;
      }

    },
    startup_logo: function(){
      if(this.startup.logo){
        console.log(this.startup.logo);
        return this.startup.logo.$oid;
      }
      else{
        return null;
      }

    },
    canGoBack() {
      // console.log("router");
      // console.log(this.$router.currentRoute.matched);
      // console.log(window.history);
      //return this.$router.history.length > 1;
      if(window.history)
        if(window.history.length > 1)return true;
      return false;

    }
  },
  methods:{
    sendAffinity(){
        console.log("OK");

        if(this.$store.state.affinityConfig){
        console.log(this.$store.state.affinityConfig);
        this.loadingAffinity = true;
        api.post(process.env.VUE_APP_API_URL+"/restrict/sync_startup_affinity",
            {
              candidates : [this.$route.params.id],
              affinityConfig : this.$store.state.affinityConfig
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            this.loadingAffinity = false;
            toast.success("Selected companies have been synchronized in Affinity ");
          }).catch( (e) => {
            if(e.response.data.undone){
              e.response.data.undone.forEach((item) => {
                  toast.error("Impossible to add "+item.name+" on Affinity",{description:"Reason : "+item.reason,duration:10000});
              });
            }
            else{
              if(e.response.data.message){
                  toast.error(e.response.data.message,{duration:10000});
              }
              else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

            }
            this.loadingAffinity = false;
          });
        }
        else{
          toast.error("Your affinity connection informations are not set or incorrect. Please contact us to fix them.");
              this.loadingAffinity = false;
        }
        this.dialogAffinity = false;
    },
    openModalList(){
      console.log(this.sf);
      this.dialogList = true;
    },
    closeModalList(){
      this.dialogList = false;
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r.toLowerCase();
      }catch{
        return formated.toLowerCase();
      }
    },
    toExistingAlt(v){
      api.post(process.env.VUE_APP_API_URL+"/restrict/add_startup_to_list_multiple",
          {
            poolids : v,
            candidates : [this.$route.params.id],
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("Innovators successfully added to list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.dialogListAlt =false;
    },
    toExisting(v){
      console.log(v);
      console.log("ARE SELECTED",this.are_selected);
      api.post(process.env.VUE_APP_API_URL+"/restrict/add_startup_to_list",
          {
            poolid : v,
            candidates : [this.$route.params.id],
            searchfield : this.sf
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("TO EXISTING LIST",r);
          toast.success("Innovators successfully added to list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      this.dialogList = false;
    },
    toNewList(v){
      console.log(v);
      api.post(process.env.VUE_APP_API_URL+"/restrict/create_new_list",
          {
            pool_name : v,
            candidates : [this.$route.params.id],
            searchfield : this.sf
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("TO NEW LIST",r);
          toast.success("List successfully created with selected candidates");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      this.dialogList = false;
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    submitStartup(){
      toast.success("Assessment submit for innovator "+this.startup.name);
      this.startup.isSubmit = true;
    },
    onHide(){
      this.visibleRef_readiness = false;
      this.visibleRef_analytical_support =false;
      this.visibleRef_strategic_fit = false;
    },
    generateAssessment(){
      var to_assess = [this.startup];
      if(to_assess.length > 0){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/generate_new_assessment/"+this.sf,
            {
                candidates: to_assess
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r.data);
            toast.success("New assessment have been asked to Innopearl Team");
            this.can_assess = false;
            this.reload();
          }).catch( (e) => {
            console.log(e);
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }
      else{
        toast.error("All the selected innovators are already in the assessment stage");

      }

    },
    reload(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/startup/"+this.$route.params.id).then( (r) => {
        // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
        // console.log();
        console.log(r.data);
        var temp = _.merge(this.startup, r.data)
        this.startup = temp;
        if(!this.startup.investment_raised)this.startup.investment_raised = {
          value : 0,
          unit:null,
          currency: null
        }
        if(!this.startup.market_potential)this.startup.market_potential = {
          value : 0,
          unit: null,
          currency: null
        }
        if(!this.startup.last_funding_round)this.startup.last_funding_round = {
          value : 0,
          unit: null,
          currency: null
        }

        if(!this.startup.revenue)this.startup.revenue = {
          value : 0,
          unit: null,
          currency: null
        }
        if(!this.startup.growth)this.startup.growth = {
          m12 : null,
          m6: null,
          m3: null
        }
        if(!this.startup.location)this.startup.location = [];
      }).catch( (e) => {
      if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
      else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
    }
  },
  mounted(){
    console.log(this.$route.query);
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
    this.showAffinity = (this.$store.state.affinityConfig == null || this.$store.state.affinityConfig == 'null') ? false :true;

    if(this.$route.query){
      if(this.$route.query.sf){
        this.sf = this.$route.query.sf;
        if(this.sf != "undefined"){
          api.post(process.env.VUE_APP_API_URL+"/restrict/isTheStartupAssess",
              {
                startup : this.$route.params.id,
                sf : this.sf
              },
              {
                headers: {
                    'Content-Type': 'application/json',
              }
            }).then( (r) => {
              console.log(r);
              if(r.data == true){
                        this.can_assess = false;
              }
              else{
                        this.can_assess = true;
              }

            }).catch( () => {
                toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
            });
        }

      }
    }
    api.get(process.env.VUE_APP_API_URL+"/restrict/startup/"+this.$route.params.id).then( (r) => {
      // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
      // console.log();
      console.log(r.data);
      var temp = _.merge(this.startup, r.data)
      this.startup = temp;
      this.pageInfo.subTitle = this.startup.name;
      this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
      if(!this.startup.investment_raised)this.startup.investment_raised = {
        value : 0,
        unit:null,
        currency: null
      }
      if(!this.startup.market_potential)this.startup.market_potential = {
        value : 0,
        unit: null,
        currency: null
      }
      if(!this.startup.last_funding_round)this.startup.last_funding_round = {
        value : 0,
        unit: null,
        currency: null
      }

      if(!this.startup.revenue)this.startup.revenue = {
        value : 0,
        unit: null,
        currency: null
      }
      if(!this.startup.growth)this.startup.growth = {
        m12 : null,
        m6: null,
        m3: null
      }
      if(!this.startup.location)this.startup.location = [];
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
    else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
  });
},
}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;

}
.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
.startup_banner_container{
  width:100%;
  padding:0;
}
img.startup_banner{
  width: 100%;
  height: 350px;
  object-fit: cover;
  object-position: center;
}

.assessment{
  margin-top:100px;
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 200px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}
.padding20{
  padding:20px;
}
.jauge_label{
  text-align:left !important;
}

.grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap : 10px 20px;
}

@media screen and (max-width:990px){

  .grid{
    display:grid;
    grid-template-columns: 1fr;
    gap : 10px 20px;
  }
}


.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
}

.contactZone{
  border:2px solid #B38D2F;
  border-radius:10px;
  padding:20px 50px;
  width:auto;
}
@media screen and (max-width:1000px){
  .contactZone{
    margin-top:20px;
  }
}
.tdore{
  color: #B38D2F !important;
}
.contactZone h5,
.content_div h5{
  display:block;
    color: #4C81C0 !important;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #4C81C0 !important;
  font-weight: 600;
}
.contactInfo a{
  color: #4C81C0 !important;
  font-weight: 600;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000 !important;
  font-weight: 600;
}
.startupName{
  width:100%;
  text-transform: uppercase;
  color:#4C81C0;
  font-weight: bold;
    padding:20px 50px;
    font-size: 25px;
  background:#FFF;
}



.action_btn,
.action_btn:hover{
  background: #FFF;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
  color:#4c81c0 !important;
  width:auto !important;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
}

.zoneBtn{
  position:relative;
  display: flex;

}


.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.startup_banner{

  position:relative;
  height:300px;
  background:#fff;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.startup_logo{
  width: 300px;
    height: 150px;
    position: absolute;
    left: 50px;
    bottom: -75px;
    z-index: 999;

}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}
.startup_logo .alt{
  width: 300px;
    height: 150px;

}
.startup_logo_inside{
  position:relative;
  -webkit-box-shadow: 0px 0px 20px -4px #CCC;
  box-shadow:0px 0px 20px -4px #CCC;
  background:#FFF;
}
.pad0{
  padding:0;
}
.tblue{
    color: #4C81C0 !important;
}
.pl20{
  padding-left:20px !important;
}

.startup{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}


.contactInfoItem{
  color:#B38D2F !important;
}
.contactInfoItem a,
.contactInfoItem a:hover,
.contactInfoItem span
{
  color:#FFF !important;
}
.contactInfo_kcn{
  color:#FFF;
  font-weight: 600;
    font-size:18px;
}

.contactInfoItem{
  margin-bottom: 10px;
}
.mb20{
  margin-bottom: 20px;
}

.contactZone .editContact{
  color:#FFF !important;
}

.dflexcontact{
  display:flex;
  align-items: center;
  gap:10px;
}

.contactIcon i{
  font-size: 30px;
    background: #3584C6;
    padding: 25px;
    color: #FFF;
    border-radius: 50%;
}
.contactInfoItem *{
  word-break:break-all;
}

.fblue{
  background: #3584C6;
    padding: 15px;
    color: #FFF;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 15px;

}
.cmail a,
.cmail a:hover,
.ctel a,
.ctel a:hover{
    color:inherit;
}
.cmail i{
font-size:25px;
border-radius: 50%;
  margin-right: 10px;
}
.mr20{
      margin-right: 10px;
}
.crole{
  margin-left:20px;
}

.clinks{
  display:flex;
  gap:10px;
  justify-content: end;
}

.clinks i{

    background: #fff;
    border:1px solid #3584C6;
      padding: 15px;
      color: #3584C6;
      border-radius: 50%;
      font-size: 20px;


}

@media screen and (min-width:1200px) and (max-width:1700px){
  .force50{
    width:50% !important;
  }
}
@media screen and (max-width:1500px){
  .force100{
    margin-top:60px;
    width:100% !important;
  }
  .revese{
  flex-direction: column-reverse;
  }

}

.cn,
.ctel,
.cmail{
  width:30%;
}

@media screen and (max-width:1500px){
.respTable{
  display:flex;
  flex-direction: column;

}
.respTable td{
  width:100%;
  border:none;
}
.clinks{
  display:flex;
  gap:10px;
}
.respTable td:last-child{
  border-bottom:1px solid #ccc;
}
}

.listOfContacts{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.listOfContacts .contactZone{
  width:calc(33% - 40px);
}

@media screen and (max-width:1500px){
  .listOfContacts .contactZone{
    width:calc(50% - 40px);
  }
}
@media screen and (max-width:990px){
  .listOfContacts .contactZone{
    width:100%;
  }
}

.tblue{
    color: #4C81C0 !important;
}
.tdore{
  color: #B38D2F !important;
}
.contactZone{
  border:2px solid #125AA4;
  background:#125AA4;
  border-radius: 10px;
  padding:20px 20px;
  width:auto;
  position:relative;
}
.contactZone h5{
  display: block;
  color: #fff !important;
  margin-bottom: 0;
  font-size:22px;
}

.fs30{
  font-size:30px;
}
</style>

<style media="screen">
  .v-window{
    border: 1px solid #3783C5;
    margin-bottom:50px;
  }
  .v-tabs{
        background: #115AA4 !important;

  }
  .v-tab--selected{
    background: #3783C5 !important;
  }
  .v-tab__slider{
    display:none;
  }
</style>
